<template lang="pug">
	OvModal(ref="modal", title="Edit Appname Blacklist", :busy="busy", @ok="save")
		div(v-if="offer")
			p.mb-2
				strong Offer:
				|  [{{ offer.id }}] {{ offer.name }}
		textarea.form-control(
			rows="12",
			v-model="value",
			:disabled="busy",
			placeholder="One app name per line",
		)
</template>

<script>
import OvModal from "@/design-system/components/OvModal.vue";

export default {
	name: "EditAppnameBlacklistModal",
	components: { OvModal },
	emits: ["saved"],
	data() {
		return {
			offer: null,
			value: "",
			busy: false,
		};
	},
	methods: {
		async open(offer) {
			if (!offer?.id) return;
			this.offer = offer;
			this.value = offer.appname_blacklist || "";
			this.$refs.modal.show();
		},

		async save() {
			if (!this.offer) return;

			this.busy = true;
			try {
				const resp = await this.$ovReq.post("advertisers/offer/updateField", {
					id: this.offer.id,
					field: "appname_blacklist",
					val: this.value,
				});
				this.value = resp.entity?.appname_blacklist ?? this.value;
				this.offer.appname_blacklist = this.value;
				this.$refs.modal.hide();
				this.$emit("saved", {
					offerId: this.offer.id,
					appname_blacklist: this.value,
				});
			} catch (e) {
				console.error(e);
			} finally {
				this.busy = false;
			}
		},
	},
};
</script>
